import * as React from 'react';
import { withManifest } from '@godaddy/gasket-hcs';
import ResellerSalesFooter from '@ux/reseller-sales-footer';

/**
 * React Component to render the Footer.
 *
 * @param {Object} props The props for this component
 * @returns {React.ReactElement} JSX for footer
 */
export function Footer(props) {
  return <ResellerSalesFooter { ...props } />;
}

/**
 * Export Header with Manifest HOC.
 *
 * @component
 * @public
 */
export default withManifest(Footer, { componentName: 'footer' });

